/**
 * Filter-panel DOM helpers. Event drawing remains owned by index.js.
 */
export function getCheckedEventTypeFilters(documentRef = document) {
  return Array.from(
    documentRef.querySelectorAll('input[name="eventTypes"]:checked')
  ).map(cb => cb.value)
}

export function initEventFilterActionButtons(
  options = {},
  documentRef = document
) {
  const applySelection =
    options.applySelection || (() => window.applyEventTypeFilterSelection())

  function addEventTypeButtonsIfMissing() {
    const filterDiv = documentRef.getElementById('eventTypeFilters')
    if (!filterDiv) return
    if (documentRef.getElementById('selectAllEventsBtn')) return

    const btnDiv = documentRef.createElement('div')
    btnDiv.className = 'event-filter-actions'
    btnDiv.innerHTML = `
      <button id="selectAllEventsBtn" style="padding:6px 16px; font-size:16px;">Show All Events</button>
      <button id="deselectAllEventsBtn" style="padding:6px 16px; font-size:16px;">Hide All Events</button>
    `
    filterDiv.appendChild(btnDiv)

    documentRef.getElementById('selectAllEventsBtn').onclick = () => {
      documentRef.querySelectorAll('input[name="eventTypes"]').forEach(cb => {
        cb.checked = true
      })
      applySelection()
    }
    documentRef.getElementById('deselectAllEventsBtn').onclick = () => {
      documentRef.querySelectorAll('input[name="eventTypes"]').forEach(cb => {
        cb.checked = false
      })
      applySelection()
    }
  }

  const eventTypeFiltersNode = documentRef.getElementById('eventTypeFilters')
  if (eventTypeFiltersNode) {
    const observer = new MutationObserver(addEventTypeButtonsIfMissing)
    observer.observe(eventTypeFiltersNode, {
      childList: true,
      subtree: true,
    })
  }
  addEventTypeButtonsIfMissing()
}
